import { createI18nLoader } from '@indutrust/shared-util';

export const i18nLoader = createI18nLoader(
  async (lang) => import(`./${lang}.json`)
);
